import type { SelectableCardItem } from '@shared/ui/forms/SelectableCardList';
import type { EligibleLocation } from './api';

export function formatAccessInviteLocationLabel(location: {
  name?: string | null;
  location_code?: string | null;
  label?: string | null;
}): string {
  const name = location.name ?? location.label ?? 'Property';
  return location.location_code ? `${name} (${location.location_code})` : name;
}

export function toAccessInviteLocationCardItems(
  locations: EligibleLocation[],
): SelectableCardItem[] {
  return locations.map((location) => ({
    id: location.location_id,
    title: formatAccessInviteLocationLabel(location),
    subtitle: location.address,
  }));
}
